import script from "./EditableText.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableText.vue?vue&type=script&lang=ts&setup=true"

import "./EditableText.vue?vue&type=style&index=0&id=37c4a6d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c4a6d0"]])

export default __exports__